import axios, {AxiosResponse} from 'axios';

import {
  ActivateProviderCompanyStoresResponse,
  CreateProviderCompanyRequest,
  CreateProviderCompanyResponse,
  ProviderCompany,
} from '../models';

/**
 * Conta do fornecedor no account-service (`/v1/provider-companies`, só
 * Mecanizou). Mesmo padrão do `createProviderAccount` (accounts.ts), que segue
 * para a ativação antiga de uma filial por vez. Mais um Admin da rede não sai
 * daqui: vai pela porta Ops do PHS, que corta sessão e limpa carteira.
 */
const API_URL = process.env.REACT_APP_API_URL;
const PROVIDER_COMPANIES_URL = `${API_URL}/v1/provider-companies`;

/** Limite da rota `GET ?provider_uids=`. */
export const PROVIDER_COMPANIES_LIST_LIMIT = 100;

/**
 * 201 quando cria a conta, 200 quando ela já existia (idempotente). O Admin
 * da rede vai pelo contato ou, depois de um 409 `USER_AMBIGUOUS`, pelo
 * `user_uid` do cadastro escolhido (nunca os dois; só Mecanizou).
 */
export const createProviderCompany = (
  body: CreateProviderCompanyRequest
): Promise<CreateProviderCompanyResponse> =>
  axios
    .post(PROVIDER_COMPANIES_URL, body)
    .then((d: AxiosResponse<CreateProviderCompanyResponse>) => d.data);

/** Até 10 filiais por chamada; resultado por filial, sem transação entre elas. */
export const activateProviderCompanyStores = (
  companyAccountUid: string,
  warehouseUids: string[]
): Promise<ActivateProviderCompanyStoresResponse> =>
  axios
    .post(`${PROVIDER_COMPANIES_URL}/${companyAccountUid}/stores`, {
      warehouse_uids: warehouseUids,
    })
    .then((d: AxiosResponse<ActivateProviderCompanyStoresResponse>) => d.data);

/** Fornecedor sem conta não aparece na resposta. Até 100 por chamada. */
export const listProviderCompanies = (
  providerUids: string[]
): Promise<ProviderCompany[]> =>
  axios
    .get(PROVIDER_COMPANIES_URL, {
      params: {provider_uids: providerUids.join(',')},
    })
    .then((d: AxiosResponse<ProviderCompany[]>) => d.data || []);

/**
 * Todas as contas (`?all=true`, só Mecanizou): os `provider_uid` delas são o
 * filtro Partner Hub da lista de fornecedores, aplicado no CRM.
 */
export const listAllProviderCompanies = (): Promise<ProviderCompany[]> =>
  axios
    .get(PROVIDER_COMPANIES_URL, {params: {all: 'true'}})
    .then((d: AxiosResponse<ProviderCompany[]>) => d.data || []);

export const getProviderCompany = (
  providerUid: string
): Promise<ProviderCompany | null> =>
  axios
    .get(PROVIDER_COMPANIES_URL, {params: {provider_uid: providerUid}})
    .then((d: AxiosResponse<ProviderCompany[]>) => d.data?.[0] || null);
